import { FC, useState } from 'react';
import NavBar from '../../partials/NavBar';
import SideBar from '../../partials/SideBar';
import cn from 'classnames';
import './Master.css';
import Footer from '../../partials/Footer';
import { Outlet } from 'react-router-dom';


const Master: FC = () => {
	const [sideBarActive, setSideBarActive] = useState(false);

	return (
		<div>
			<SideBar
				active={sideBarActive}
				setSideBarActive={setSideBarActive}
			/>
			<div
				className={cn('transition duration-500 mainContainer relative pb-14', {
					'mini-sidebar': sideBarActive === false,
				})}
			>
				<NavBar
					active={sideBarActive}
					setSideBarActive={setSideBarActive}
				/>
				<main id='content'>
					<Outlet/>
				</main>
				<Footer />
			</div>
		</div>
	);
};

export default Master;
